<!--
 * @Descripttion: 会员缴费，和管理端逻辑一致
 * @Author: zhangkaixing
 * @Date: 2022-05-17 17:43:41
 * @LastEditors: zhangkaixing
 * @LastEditTime: 2021-10-11 10:00:24
-->
<template>
  <el-card shadow="never">
    <div>
      <b style="font-size:24px">平台服务费支付</b>
      <div class="money"><span>支付费用：</span><font>￥ {{orderData.amount}} 元</font></div>
      <el-divider></el-divider>
      <div class="bank-type">
        <span style="font-size:18px">付款方式：</span>
        <el-radio-group v-model="payway" @change='changePayType'>
           <el-radio label="WXPAY" border>
            <img src="@/assets/img/wxicon.png" height="24">
            <span class="name" >微信</span>
          </el-radio>
          <el-radio label="ALIPAY" border disabled>
            <img src="@/assets/img/zfbicon.png" height="24">
            <span class="name" >支付宝 (暂不支持)</span>
          </el-radio>
          <el-radio label="YHZZ" border>
            <img src="@/assets/img/databackup.png" height="24">
            <span class="name" >银行转账</span>
          </el-radio>
        </el-radio-group>
      </div>
      <el-divider v-if="payway=='WXPAY'||payway=='YHZZ'"></el-divider>
      <div class="bg WXPAY"  v-if="payway=='WXPAY'&&!paySuccess">
          <img class='core' :src="getCore()" width="200" height="200" />
          <!-- <div class="paySuc" v-else>
            <img :src="paySuc()" width="50" height="50" />
            <p class="tip">支付成功</p>
          </div> -->
      </div>
      <div class="bg paySuccess" v-if="paySuccess">
        <img  src="@/assets/img/success.png" width="100" height="100" />
        <div style="font-size:20px;color:#67C23A;padding-top:10px">{{paymentType == 1 ? '单位': '个人'}}已缴费</div>
      </div>
      <div v-if="payway=='YHZZ'" class="yhzz">
        <p>您也可以通过以下支付方式进行会费缴纳，河北省建设工程招标投标协会的{{paymentType == 1 ? '': '个人'}}会费为每年{{orderData.amount}}元。</p>
        <p>协会名称：河北省建设工程招标投标协会（行号：105121061025）<br/>
开户银行：建行石家庄新华路东支行<br/>
银行账号：1300 1618 8030 5999 9999<br/>
协会地址：石家庄市新华路296号（盛安大厦六楼）<br/>
为了能够保证缴费会员单位及时收到电子发票，请缴费单位在电汇后将本单位名称、税号、联系人、手机号等信息发送至邮箱:3501230150@qq.com。</p>
        <p>支付后，河北省建设工程招标投标协会的客服人员会在1-2个工作日内更新您的会费缴纳信息。</p>
        <p>咨询电话：0311-87829147（财务）&nbsp;&nbsp;&nbsp;&nbsp; 0311-67669636（办公室）</p>
      </div>
    </div>
    <!-- <div style="margin-top:20px" v-if="payway=='ALIPAY'">
      <el-button  class="paybtn" type="primary" @click="pay">去支付</el-button>
    </div> -->
    <div style="text-align:center;"  v-if="payway=='WXPAY'&&!paySuccess" >
      <el-button type="success" style="font-size:16px" @click="wxPayed" :loading='payedload'>确定完成支付</el-button>
      <p style="color:#409eff;font-size:32px;margin:10px">完成扫码支付后，请点击此按钮进行状态更新！</p>
    </div>
  </el-card>
</template>

<script>
export default {
  data () {
    return {
      getDicListURL: '/sys/dict/type/',
      payway: 'WXPAY',
      orderData: {
        amount: ''
      },
      payedload: false,
      paySuccess: false,
      paymentType: '', // 1单位缴费2个人缴费
      url: ''
    }
  },
  created () {
    this.url = process.env.VUE_APP_apiURL
    this.getOrderCode()
  },
  destroyed () {
    if (!this.paySuccess) {
      this.getOrderCode(2)
    }
  },
  components: {},
  methods: {
    getOrderCode (val) {
      this.$get('/pay/paygoodsorder/personalCreatePayGoods').then((res) => {
        if (res.data.payType === '63') {
          this.payway = 'YHZZ'
        } else if (res.data.payType === '52') {
          this.payway = 'ALIPAY'
        } else if (res.data.payType === '41') {
          this.payway = 'WXPAY'
        }
        if (res.code === 0) {
          this.paymentType = res.data.paymentType
          if (val && (res.data.payType === '41' || res.data.payType === null)) {
            // 已支付,val判断是否点击刷新支付状态,res.data.payType判断是微信支付或者未支付时，才走刷新状态接口
            this.payedload = true
            this.$get(`/pay/pay/query?code=${res.data.payOrderId}&key=${this.payway}`).then((res) => {
              if (res.code === 0) {
                if (res.data) {
                  this.paySuccess = true
                } else {
                  if (val === 1) {
                    this.$message.error('支付失败!')
                  }
                }
              }
              this.payedload = false
            })
          }
          if (res.data.status === 1) {
            // 已支付
            this.orderData.amount = res.data.amount
            this.paySuccess = true
          } else {
            this.orderData = res.data
          }
        }
      })
    },
    wxPayed () {
      this.getOrderCode(1)
      // this.payedload = true
      // this.$http.get(`/pay/pay/query?code=${this.orderData.payOrderId}&key=${this.payway}`).then((res) => {
      //   if (res.code === 0) {
      //     if (res.data) {
      //       this.paySuccess = true
      //     } else {
      //       this.$message.error('支付失败！')
      //     }
      //   }
      //   this.payedload = false
      // })
    },
    changePayType () {
      if (this.payway === 'WXPAY') {
        // 微信支付
        this.getCore()
      }
    },
    getCore () {
      let payCode = this.orderData.code.indexOf('-') > -1 ? this.orderData.code : (this.orderData.code + '-' + new Date().getTime())
      let core = this.url + `/pay/pay/precreate?payCode=${payCode}&key=${this.payway}`
      return core
    },
    pay () {
      if (this.payway === 'ALIPAY') {
        window.location.href = this.url + `/pay/pay/order?payCode=${this.orderData.payOrderId}`
      } else {
        // this.qrload = true
        // this.dialogVisible = true
        // setTimeout(() => {
        //   this.qrload = false
        //   this.initWebSocket()
        // }, 500)
      }
    }
    // getLibrary () {
    //   this.$http.get('/exam/etexaminationlibrary/getExaminationLibraryList').then((res) => {
    //     if (res.code === 0) {
    //       this.libraryArr = res.data
    //       this.dataForm.libraryNamme = res.data[0].code
    //     }
    //   })
    // }
  }
}
</script>
<style scoped>
.bank-type /deep/.el-radio__label img {
  height: 24px;
  position: absolute;
  top: 7px;
}
.bank-type /deep/.el-radio__label .name {
  padding-left: 30px;
}
div/deep/.el-divider--horizontal{margin: 15px 0!important;}
.money{display: flex;align-items: center;font-size: 18px;padding-top: 20px;}
.money font{font-size: 32px;}
.paybtn{margin-left: 90px;}
.WXPAY {
  padding-top: 30px;
  background: url(~@/assets/img/WXPAYBG.jpg) no-repeat;
  background-size: 100% 100%;
}
.bg {
  width: 469px;
  height: 214px;
  margin: 0 auto;
}
.WXPAY .core{position: relative;  top: 0;  left: 33px;}
.paySuccess{text-align: center;padding-top: 50px;}
.yhzz p{font-size: 18px;font-weight: bold;color: #444;padding: 0 100px;line-height: 30px;}
</style>
